import React from 'react';

import Heading from '../heading/Heading';
import List from '../List';

const HowTos = ({ sewpat }) => {

    const getContent = () => sewpat.howtos.content.map((content, index) =>
        <span key={index} dangerouslySetInnerHTML={{ __html: content }} />,
    );

    return (
        <React.Fragment>
            <Heading
                text={sewpat.howtos.label}
                level={3}
            />
            <List items={getContent()} />
        </React.Fragment>
    );
};

export default HowTos;



// WEBPACK FOOTER //
// ./src/components/sewpat/HowTos.js